export const config = {
  publicUrl: process.env.PUBLIC_URL || "",
  trademarkUiUrl: process.env.REACT_APP_TRADEMARK_UI_URL,
  customerApiUrl: process.env.REACT_APP_CUSTOMER_API_URL,
  ordersApiUrl: process.env.REACT_APP_ORDERS_API_URL,
  usersApiUrl: process.env.REACT_APP_USERS_API_URL,
  envName: process.env.ENV_NAME || "dev",
};
